import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import * as resolvType from "../../utils/resolveType.js";

const Checkbox = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Auswerten, ob Aktiv
  let bitValue;

  // Array und Bit auflösen
  if (props.element.bit !== undefined) {
    if (props.element.index !== undefined) {
      const arrayValue = resolvType.readArray(value.value, props.element.index);
      let type;
      try {
        if (value.type.includes("ARRAY_INT")) {
          type = "INT";
        } else if (value.type.includes("ARRAY_UINT")) {
          type = "UINT";
        } else if (value.type.includes("ARRAY_DINT")) {
          type = "DINT";
        }
      } catch (error) {}

      bitValue = resolvType.readBit(arrayValue, props.element.bit, type);
    } else {
      bitValue = resolvType.readBit(value.value, props.element.bit, value.type);
    }
  } else {
    bitValue = value.value;
  }

  let isChecked = bitValue === "1";

  //========================================================================
  // neuen Wert schreiben
  const handleInputChange = () => {
    let verifiedValue;
    if (bitValue === "1") {
      verifiedValue = "0";
    } else {
      verifiedValue = "1";
    }

    // Wert in globalVars schreiben
    let valueToWrite;

    // Array und Bit auflösen
    if (props.element.bit !== undefined) {
      if (props.element.index !== undefined) {
        let readArray = resolvType.readArray(value.value, props.element.index);
        let type;
        try {
          if (value.type.includes("ARRAY_INT")) {
            type = "INT";
          } else if (value.type.includes("ARRAY_UINT")) {
            type = "UINT";
          } else if (value.type.includes("ARRAY_DINT")) {
            type = "DINT";
          }
        } catch (error) {}

        const wordValue = resolvType.writeBit(
          readArray,
          props.element.bit,
          verifiedValue,
          type
        );

        try {
          if (value.type.includes("ARRAY_INT")) {
            type = "INT";
          } else if (value.type.includes("ARRAY_UINT")) {
            type = "INT";
          } else if (value.type.includes("ARRAY_DINT")) {
            type = "INT";
          }
        } catch (error) {}

        valueToWrite = resolvType.writeArray(
          value.value,
          props.element.index,
          wordValue,
          type
        );
      } else {
        valueToWrite = resolvType.writeBit(
          value.value,
          props.element.bit,
          verifiedValue,
          value.type
        );
      }
    } else {
      valueToWrite = verifiedValue;
    }

    if (props.authWrite) {
      rwData.writeValue(
        props.props.variable.toString(),
        valueToWrite.toString(),
        value.value
      );
    }
    // console.log(props.props.variable.toString(), valueToWrite.toString());
  };

  //########################################################################################################
  //############################### Grafische Darstellung ##################################################
  //########################################################################################################
  return (
    <input
      style={{
        ...props.style,
        visibility: props.props.visibility,
        cursor: "pointer",
        accentColor: props.style.backgroundColor,
      }}
      type="checkbox"
      checked={isChecked}
      onChange={handleInputChange}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
    />
  );
});

export default Checkbox;
